// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"06b574ec","202":"cab61c40","252":"e21c481a","254":"b0e97650","419":"528265fe","563":"91f02341","654":"d00f1cf5","774":"4761204c","883":"caf0e6d5"}[chunkId] + ".chunk.js";
};